import { Button, Card, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/context/AuthContext';
import { canWriteAliados } from '@/layouts/navigation';
import { AllyTable } from '../components/AllyTable';
import { useAllies } from '../hooks/useAllies';

/**
 * Listado de Aliados (US-2.2, `/aliados`) — paginación server-side vía `useAllies`.
 * La escritura es solo de `SUPER_ADMIN` (contrato): el botón de alta y el CTA del
 * empty-state se ocultan al resto de roles para no ofrecer un 403.
 */
export function AlliesListPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const allies = useAllies();

  const canCreate = canWriteAliados(user?.role);
  const goToCreate = () => navigate('/aliados/nuevo');

  return (
    <div className="aliados-page">
      <div className="aliados-page__header">
        <Typography.Title level={3} style={{ margin: 0 }}>
          Aliados
        </Typography.Title>
        {canCreate && (
          <Button type="primary" icon={<PlusOutlined />} onClick={goToCreate}>
            Nuevo aliado
          </Button>
        )}
      </div>

      <Card>
        <AllyTable
          allies={allies.data}
          meta={allies.meta}
          loading={allies.loading}
          error={allies.error}
          filters={allies.filters}
          canCreate={canCreate}
          onFiltersChange={allies.setFilters}
          onOffsetChange={allies.setOffset}
          onRetry={allies.refresh}
          onCreate={goToCreate}
          onSelect={(allyId) => navigate(`/aliados/${encodeURIComponent(allyId)}`)}
        />
      </Card>
    </div>
  );
}
